
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Intro() {
  const [animationStage, setAnimationStage] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer1 = setTimeout(() => setAnimationStage(1), 300);   // Show B
    const timer2 = setTimeout(() => setAnimationStage(2), 600);   // Show l
    const timer3 = setTimeout(() => setAnimationStage(3), 900);   // Show e
    const timer4 = setTimeout(() => setAnimationStage(4), 1200);  // Show c
    const timer5 = setTimeout(() => setAnimationStage(5), 1500);  // Show I
    const timer6 = setTimeout(() => setAnimationStage(6), 1800);  // Show n
    const timer7 = setTimeout(() => setAnimationStage(7), 2100);  // Show k
    const timer8 = setTimeout(() => setAnimationStage(8), 2400);  // Add glow effect
    const timer9 = setTimeout(() => {
      navigate('/home');
    }, 3500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
      clearTimeout(timer6);
      clearTimeout(timer7);
      clearTimeout(timer8);
      clearTimeout(timer9);
    };
  }, [navigate]);

  const handleSkip = () => {
    navigate('/home');
  };

  const letters = ['B', 'l', 'e', 'c', 'I', 'n', 'k'];

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center overflow-hidden">
      {/* Skip button */}
      <button
        onClick={handleSkip}
        className="absolute top-8 right-8 text-white/60 hover:text-white text-sm font-medium transition-colors duration-300 z-20 cursor-pointer whitespace-nowrap"
      >
        Skip Intro
      </button>

      {/* Main animation container */}
      <div className="relative flex items-center justify-center">
        {/* Letter-by-letter reveal */}
        <div className="flex items-center justify-center">
          <div className="text-white font-bold text-6xl md:text-8xl transition-all duration-800" 
               style={{ fontFamily: 'Helvetica Neue, Arial, sans-serif', letterSpacing: '0.05em' }}>
            {letters.map((letter, index) => (
              <span
                key={index}
                className={`inline-block transition-all duration-500 ${
                  animationStage > index 
                    ? 'opacity-100 transform translate-y-0 scale-100' 
                    : 'opacity-0 transform translate-y-4 scale-90'
                }`}
                style={{
                  transitionDelay: `${index * 100}ms`
                }}
              >
                {letter}
              </span>
            ))}
          </div>
        </div>

        {/* Glow effect */}
        <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-1000 ${
          animationStage >= 8 ? 'opacity-30' : 'opacity-0'
        }`}>
          <div className="text-teal-400 font-bold text-6xl md:text-8xl blur-lg" 
               style={{ fontFamily: 'Helvetica Neue, Arial, sans-serif', letterSpacing: '0.05em' }}>
            BlecInk
          </div>
        </div>

        {/* Subtle pulse effect when complete */}
        <div className={`absolute inset-0 flex items-center justify-center transition-all duration-800 ${
          animationStage >= 8 ? 'scale-105' : 'scale-100'
        }`}>
          <div className="text-transparent font-bold text-6xl md:text-8xl" 
               style={{ fontFamily: 'Helvetica Neue, Arial, sans-serif', letterSpacing: '0.05em' }}>
            BlecInk
          </div>
        </div>
      </div>

      {/* Loading indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2">
        <div className="w-32 h-1 bg-white/20 rounded-full overflow-hidden">
          <div 
            className="h-full bg-white rounded-full transition-all duration-3500 ease-out"
            style={{ width: animationStage >= 8 ? '100%' : `${(animationStage / 8) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
}
